import React from "react"

function Win() {
    return(
        <div className="bg-2 flex h-screen switfy-text win-image zoom">
            <h1 className="text-6xl sm:text-8xl mt-8 ml-2">THE END</h1>
        </div>
    )
}
export default Win